module.exports = __webpack_public_path__ + "img/vijaysales.8f4876a9.png";